import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';
import { RenderContextComponent } from '../../../../../../../../../models/base/render-context-component';

@Component({
  selector: 'app-glass-house-description',
  templateUrl: './glass-house-description.component.html',
  styleUrl: './glass-house-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseDescriptionComponent extends RenderContextComponent {
  @Input() data: GlassHouseBrandGroupCardData;
  setupViews() {}
  setupBindings() {}
}
